import { Molecule } from 'openchemlib';

export function ensureSmiles(reagent) {
  if (reagent.smiles) return;
  if (reagent.molfile) {
    reagent.smiles = Molecule.fromMolfile(reagent.molfile).toSmiles();
  }
  if (reagent.ocl?.value) {
    reagent.smiles = Molecule.fromIDCode(reagent.ocl.value).toSmiles();
  }
  if (reagent.ocl?.idCode) {
    reagent.smiles = Molecule.fromIDCode(reagent.ocl.idCode).toSmiles();
  }
}
